import { Breadcrumbs } from '@components/breadcrumbs/breadcrumbs'
import { ScrollArea } from '@components/scroll-area/scroll-area'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import { useIsTablet } from '@utils/hooks/use-is-tablet'
import { Outlet } from 'react-router-dom'

export const InnerLayout = () => {
  const isTablet = useIsTablet()

  return (
    <Box
      component="main"
      sx={{
        display: 'flex',
        height: 1,
        width: 1,
        overflow: 'hidden',
      }}
    >
      <Stack
        sx={{
          width: 1,
          height: 1,
          overflow: 'hidden',
        }}
      >
        {!isTablet && <Breadcrumbs />}
        <ScrollArea
          scrollbars="vertical"
          sx={{
            flex: 1,
            height: 'auto',
            minHeight: 0,
          }}
          viewportProps={{
            'data-testid': 'inner-layout-scroll-area',
            sx: {
              overflowX: 'hidden',
              '& > div': {
                display: 'block !important',
                height: '100%',
                minWidth: '0 !important',
                width: '100%',
              },
            },
          }}
        >
          <Outlet />
        </ScrollArea>
      </Stack>
    </Box>
  )
}
